import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "Home",
    component: Home
  },
  {
    path: "/purpose",
    name: "Purpose",
    component: () => import("../views/Purpose")
  },
  {
    path: "/service",
    name: "Service",
    component: () => import("../views/Service")
  },
  {
    path: "/theory",
    name: "Theory",
    component: () => import("../views/Theory")
  },
  {
    path: "/step",
    name: "Step",
    component: () => import("../views/Step")
  },
  {
    path: "/require",
    name: "Require",
    component: () => import("../views/Require")
  },
  {
    path: "/character",
    name: "Character",
    component: () => import("../views/Character")
  },
  {
    path: "/tostu",
    name: "Tostu",
    component: () => import("../views/Tostu")
  }
];

const router = new VueRouter({
  routes
});

const defaultTitle = "申报项目";
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle;
  next();
});

export default router;
